import styled from "styled-components";

export const TeamsModule = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	min-height: 0;
	flex: 1;
`;
